import { useEffect } from 'react'
import { isEmpty } from 'lodash'

import { TOOL_SOURCES, TOOL_TYPES } from './tools.constants'
import { isCardOnlyPrompt, parseAllowedUrls, supportsAllowedUrls } from './tools.helpers'

/**
 * Typing allowed URLs hides the models whose web search ignores them (mini and nano). A model
 * picked before that would stay saved but no longer shown, so clear it.
 */
export const ResetModelWhenItIgnoresUrls = ({ values, modelOptions, setFieldValue }) => {
  const hasUrls = !isEmpty(parseAllowedUrls(values.allowed_urls))
  const model = modelOptions.find((option) => option.value === values.llm_model_id)
  useEffect(() => {
    // Only while the AI model field shows: a web lookup with instructions.
    const modelShown =
      values.type === TOOL_TYPES.ENTITY_LOOKUP &&
      values.source !== TOOL_SOURCES.SHAREPOINT &&
      !isCardOnlyPrompt(values.user_prompt)
    if (modelShown && hasUrls && model && !supportsAllowedUrls(model)) {
      setFieldValue('llm_model_id', '')
    }
  }, [values.type, values.source, values.user_prompt, hasUrls, model])

  return null
}
